import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";

export default WidgetModule;
